<div class="p-row">
    <div class="p-col-12 p-text-left">
        <label class="label">{{ t('players') }}</label>
        <div class="players">
            <PlayerItem v-for="(player, index) in playersList" :key="index + '-' + (player ? player.id : index)"
                :booking_id="match.id" :player="player" :playerIds="playerIds" :index="index" @refresh="refresh" />
        </div>
    </div>
</div>